import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  AvailabilityRequestDto as RequestDto,
  AvailabilityResponseDto as ResponseDto,
} from "../../api/availability/dtos";
import { Api } from "../../api";
import { ActivityAvailability } from "../../models";
import format from "date-fns/format";

type Data = ActivityAvailability[];

interface CallParams {
  id: number;
  locationId: number;
  dates: Date[];
  weekdays?: number | number[] | null;
  personTypes: {
    id: number;
    quantity: number;
  }[];
  timeSlots: number;
}

export const timeSlots = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "ACTIVITY_TIME_SLOTS",
  Api.getTimeSlots,
  ({ data }, callParams) => {
    return data
      .map(({ activities }) => {
        if (activities[0]?.activity_id !== callParams.id) return [];
        const results = Object.entries(activities[0].results);
        return results.map(
          ([date, item]) => new ActivityAvailability({ ...item, date })
        );
      })
      .flat(1);
  },
  (params) => {
    const { locationId, id, dates, weekdays, personTypes, timeSlots } = params;

    return {
      location_id: locationId,
      dates: dates.map((date) => format(date, "dd-MM-yyyy")),
      weekdays: weekdays
        ? Array.isArray(weekdays)
          ? weekdays
          : [weekdays]
        : [],
      activities: [
        {
          activity_id: id,
          person_types: personTypes.map(({ id, quantity }) => ({
            person_type_id: id,
            quantity,
          })),
          duration: timeSlots, // in timeSlots (not minutes!)
        },
      ],
      packages: [],
    };
  }
);
